import { useQuery } from "react-query";
import { ReferentialApi } from "../../api";
import { useApiService } from "../useApiService";

export function useFormTypeRef() {
  const api = useApiService(ReferentialApi);
  const { data, isFetching, refetch } = useQuery(
    "ref-form-types",
    async () => {
      return await api.formTypes();
    },
    { staleTime: Infinity }
  );

  return {
    formTypes: data ?? [],
    formTypesLoading: isFetching,
    refetchFormTypesRef: refetch,
  };
}
